import useLevelDisplayInfo from '@api/hooks/profile/useLevelDisplayInfo';
import useLessonDetails from './useLessonDetails';
import useLessonPlayListDetails from './useLessonPlayListDetails';

const useFullLessonDetails = (playlistUID, fallbackData) => {
  const { key: lessonDetailsSWRKey, mutate: revalidateLessonDetails } =
    useLessonDetails(playlistUID, {
      fallbackData: fallbackData.lessonDetails
    });

  const {
    key: lessonPlayListDetailsSWRKey,
    mutate: revalidatePlaylistDetails
  } = useLessonPlayListDetails(playlistUID, {
    fallbackData: fallbackData.playlistDetails
  });

  const { key: levelDisplayInfoKey, mutate: revalidateLevelsDisplayInfo } =
    useLevelDisplayInfo({
      fallbackData: fallbackData.levelsDisplayInfo
    });

  return {
    keys: {
      lessonDetailsSWRKey,
      lessonPlayListDetailsSWRKey,
      levelDisplayInfoKey
    },
    revalidateLessonDetails,
    revalidatePlaylistDetails,
    revalidateLevelsDisplayInfo
  };
};

export default useFullLessonDetails;
